export const STORAGE_KEY = "mps_gate_accepted_v1";

export function hasAcceptedGate() {
  if (typeof window === "undefined") return false;
  try {
    return !!window.localStorage.getItem(STORAGE_KEY);
  } catch (_e) {
    // Safari private mode / disabled storage — treat as first-time visitor.
    return false;
  }
}

export function recordGateAcceptance() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ at: new Date().toISOString(), v: 1 }));
  } catch (_e) {
    // Silent — the gate still works this session; only persistence fails.
  }
}
